import { ApiDateSchema,
  CurrencySchema,
  PaymentProviderSchema,
  CustomerSchema,
  InvoiceSchema } from '@weft/types';
import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const InvoiceOverviewSchema = InvoiceSchema
  .pick({
    id: true,
    revenueBreakdown: true,
    billingStatus: true,
    reviewStatus: true,
    billingCycle: true,
    syncStatus: true,
    syncStatusUpdatedAt: true,
    paymentInfo: true,
  })
  .extend({
    id: ObjectIdSchema,
    customer: CustomerSchema,
    contractName: oz.string().optional(),
    issuedAt: ApiDateSchema,
    currency: CurrencySchema,
    paymentProvider: PaymentProviderSchema.optional(),
  }).openapi('InvoiceOverview');

export type InvoiceOverview = oz.infer<typeof InvoiceOverviewSchema>;